//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductTraceability from "@/Manager/10.Tms/ProductSnManager";
export default {
  props: {},
  data() {
    return {
      phoneRegex: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
      show: true,
      isCode: "发送验证码",
      count: "",
      timer: null,
      Iphone: "",
      qrCode: ""
    };
  },
  created() {},
  mounted() {},
  methods: {
    NextStep() {
      if (this.Iphone == "") {
        this.$msg.alert("请输入手机号");
        return;
      }

      if (!this.phoneRegex.test(this.Iphone)) {
        this.$msg.alert("请输入正确的手机号码");
        return;
      }

      if (this.qrCode == "") {
        this.$msg.alert("请输入验证码");
        return;
      }
      this.VerificationCode();
    },
    sedCode() {
      if (this.Iphone == "") {
        this.$msg.alert("请输入手机号");
        return;
      }

      if (!this.phoneRegex.test(this.Iphone)) {
        this.$msg.alert("请输入正确的手机号码");
        return;
      }
      this.GetCode();
    },
    timers() {
      const TIME_COUNT = 120;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    // 获取验证码
    GetCode() {
      this.$msg.showLoading("正在加载");
      var postData = {
        mobile: this.Iphone,
        activityOpenId: "5bf2d438af06432c9412da43f652f8ec"
      };
      ProductTraceability.RegisCheckCode(postData).then(res => {
        this.$msg.hideLoading();
        if (res.state == 1) {
          this.timers();
          return;
        }

        if (res.state == 0) {
          this.$msg.alert(res.msg);
        }

        console.log(res, "获取验证码");
      });
    },

    //验证验证码
    VerificationCode() {
      this.$msg.showLoading("正在加载");
      var postData = {
        mobile: this.Iphone,
        activityOpenId: "5bf2d438af06432c9412da43f652f8ec",
        smsCheckCode: this.qrCode
      };
      ProductTraceability.VerifiCode(postData).then(res => {
        this.$msg.hideLoading();
        if (res.state == 1) {
          this.$router.push("/MemberFission/PerfectInformation");
          return;
        }

        if (res.state == 0) {
          this.$msg.alert(res.msg);
        }

        console.log(res, "验证验证码");
      });
    }
  }
};
